<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Event from '@/components/base/event'
export default {
  name: 'App',
  components: { Event }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue